import { UserModule } from "@/store/modules/user"
import { IsAndroid, IsChrome, IsMobile } from "./check"

// 百度转换高德
export function bd09ToGd(bd_lat: number, bd_lon: number) {
  const x_pi = Math.PI * 3000.0 / 180.0
  const x = bd_lon - 0.0065
  const y = bd_lat - 0.006
  const z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi)
  const theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi)
  const gd_lon = z * Math.cos(theta)
  const gd_lat = z * Math.sin(theta)
  return {
    lat: gd_lat,
    lon: gd_lon
  }
}

// 高德转换百度
export function gdToBd(gd_lat: number, gd_lon: number) {
  const x_pi = Math.PI * 3000.0 / 180.0
  const x = gd_lon
  const y = gd_lat
  const z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * x_pi)
  const theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * x_pi)
  const bd_lon = z * Math.cos(theta) + 0.0065
  const bd_lat = z * Math.sin(theta) + 0.006
  return {
    lat: bd_lat,
    lon: bd_lon
  }
}

// 使用watch监听坐标变化
export function getCurrentPosition(
  view: any, geolocation: any,
  successCallback: Function, errorCallback: Function) {
  // AMap.Event.addListener(geolocation, 'complete', (result: any) => {
  //   geolocation.clearWatch()
  //   AMap.Event.removeListener(geolocation, 'complete')
  //   AMap.Event.removeListener(geolocation, 'error')
  //   successCallback(result)
  // })
  // AMap.Event.addListener(geolocation, 'error', (result: any) => {
  //   geolocation.clearWatch()
  //   AMap.Event.(geolocation, 'complete')
  //   AMap.Event.removeListener(geolocation, 'error')
  //   errorCallback(result)
  // })

  console.log('开始定位', geolocation)

  // 显示正在定位的loading消息

  const loading = view.$loading({
    lock: true,
    text: '正在定位中...',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)'
  });

  geolocation.on('complete', (result: any) => {
    geolocation.clearWatch()
    geolocation.off('complete')
    geolocation.off('error')
    console.log('定位成功', result)
    // 关闭loading消息
    loading.close()
    // view.$message.success('已定位到当前位置' + result.position + result.location_type + result.message)
    successCallback(result)
  })

  geolocation.on('error', (result: any) => {
    geolocation.clearWatch()
    geolocation.off('complete')
    geolocation.off('error')
    console.log('定位失败', result)
    // 关闭loading消息
    loading.close()
    errorCallback(result)
  })

  if (ifUseSlowLocation()) {
    geolocation.watchPosition()
  } else {
    geolocation.getCurrentPosition()
  }
}

function ifNotOpenSlowLocation() {
    if (UserModule.currentOrg?.orgConfig) {
      const obj = JSON.parse(UserModule.currentOrg.orgConfig)
      return obj.not_open_slow_location
    }
    return false
}

function ifUseSlowLocation(): boolean {
  if (ifNotOpenSlowLocation()) {
    return false
  }

  if (IsMobile() && IsAndroid() && IsChrome()) {
    return true
  }

  return false
}
